import classNames from "classnames";

import { SvgSprite } from "../SvgSprite";

interface FormValidationErrorProps {
  errorId: string;
  message: React.ReactNode;
  className?: string;
}

export const ValidationError = (props: FormValidationErrorProps) => {
  if (!props.message) return null;

  return (
    <div
      id={props.errorId}
      className={classNames("invalid-feedback", props.className)}
    >
      <SvgSprite
        id="glyph:error"
        width={15}
        height={15}
        aria-label="alert"
        className="align-text-top mr-1"
        css={`
          position: relative;
          top: 1px;
        `}
      />
      {props.message}
    </div>
  );
};
